export const engagementCampaignStatsCampaignId = "/engagement/campaign_stats/:campaign_id";
